/**
 * External service URLs used throughout the application
 */
export const EXTERNAL_URLS = {
  /**
   * Steam Community image base URL for item images
   * Used to construct full image URLs by appending the image hash
   */
  STEAM_IMAGE_BASE_URL: 'https://steamcommunity-a.akamaihd.net/economy/image/',
} as const

// Export individual constants for convenience
export const { STEAM_IMAGE_BASE_URL } = EXTERNAL_URLS

/**
 * Utility function to get the full Steam image URL
 * @param imageHash - The Steam image hash/ID
 * @returns Full Steam image URL
 * @example getSteamImageUrl('123abc') // 'https://steamcommunity-a.akamaihd.net/economy/image/123abc'
 */
export function getSteamImageUrl(imageHash: string): string {
  if (
    imageHash.startsWith('http://') ||
    imageHash.startsWith('https://') ||
    imageHash.startsWith('//')
  ) {
    return imageHash
  }

  return STEAM_IMAGE_BASE_URL + imageHash
}
